<template>
  <v-container fluid>
    <PageHeader :title="currentDocumentTypeName" icon="mdi-receipt-text-outline">
      <template #actions>
        <v-btn :to="{ name: 'LegalDocument', params: { id: 'create', legalDocumentTypeId } }" color="primary">
          <v-icon start>mdi-upload</v-icon> Upload New
        </v-btn>
      </template>
    </PageHeader>
    <v-card>
      <v-data-table
        :items-per-page="-1"
        :hide-default-footer="true"
        :must-sort="true"
        :no-data-text="''"
        :headers="headers"
        :items="documents"
        :loading="loading"
        :disable-sort="true"
        @click:row="(event, { item }) => editDocument(item)"
      >
        <template v-slot:item.insertDate="{ item }">
          <span>{{ new Date(item.insertDate).toLocaleString() }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import Auth0Mixin from "@/views/Auth0Mixin";
import PageHeader from "@/components/PageHeader.vue";
import DocumentService from "@/services/admin/legalDocumentService";
import PrivacySettingConstants from "@/constants/privacySettings";
import LegalDocumentTypes from "@/constants/legalDocumentTypeList";

let documentTypeName = documentTypeId => LegalDocumentTypes.find(x => x.id === documentTypeId)?.name;

export default {
  name: "LegalDocumentList",
  props: ["documentType", "legalDocumentTypeId"],
  mixins: [Auth0Mixin],
  components: { PageHeader },
  data() {
    return {
      headers: [
        { title: "Upload Date", key: "insertDate" },
        { title: "Privacy", key: "privacySettingDescription" },
        { title: "Is Active", key: "isActive" },
        { title: "DocumentType", key: "documentType" },
        { title: "", key: "replace", width: "10%" },
      ],
      documents: [],
      loading: true,
      replaceDocumentData: {
        id: null,
        file: null,
      },
    };
  },
  computed: {
    currentDocumentTypeName() {
      return documentTypeName(this.legalDocumentTypeId);
    },
  },
  methods: {
    async init() {
      await this.queryDocuments();
    },
    async queryDocuments() {
      this.loading = true;
      const result = await DocumentService.searchDocuments({ legalDocumentTypeId: this.legalDocumentTypeId });
      this.documents = result.items.map(x => ({
        ...x,
        documentType: documentTypeName(x.legalDocumentTypeId),
        privacySettingDescription: PrivacySettingConstants.getById(x.privacySettingId).description,
      }));
      this.loading = false;
    },
    editDocument(document) {
      this.$router.push({
        name: "LegalDocument",
        params: { legalDocumentTypeId: this.legalDocumentTypeId, id: document.id },
      });
    },
    async replaceDocument(id) {
      this.replaceDocumentData.id = id;
      this.$refs.replaceUpload.$refs.input.click();
    },
    async replaceFile(file) {
      try {
        if (!file) return;
        await DocumentService.replaceDocument(file, this.replaceDocumentData.id);
        this.replaceDocumentData = { file: null, id: null };
        this.$root.$snackbar.message("Successfuly replaced the document");
        this.queryDocuments();
      } catch (e) {
        this.$root.$snackbar.error("Cannot upload the new document. Contant support.");
      }
    },
  },
  watch: {
    async legalDocumentTypeId() {
      await this.queryDocuments();
    },
  },
};
</script>
